function ifCond2 (v1, operation, v2, options) {
    let condition = false;

    if (operation === '>') {
        condition = v1 > v2;
    } else if (operation === '>=') {
        condition = v1 >= v2;
    } else if (operation === '<') {
        condition = v1 < v2;
    } else if (operation === '<=') {
        condition = v1 <= v2;
    } else if (operation === '||') {
        condition = v1 || v2;
    } else if (operation === '!=') {
        condition = v1 !== v2;
    }

    if (condition) {
        return options.fn(this);
    }

    return options.inverse(this);
}

export default ifCond2;
